import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="footer-logo-icon">🎨</span>
              <span className="footer-logo-text">Sicilia Artwork Tracker</span>
            </div>
            <p className="footer-description">
              Professional artwork management system for cultural institutions
              and collectors.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">Features</h4>
            <ul className="footer-links">
              <li>
                <span>📋</span> Artwork Management
              </li>
              <li>
                <span>📞</span> Operation Tracking
              </li>
              <li>
                <span>⏭️</span> Next Actions
              </li>
              <li>
                <span>📊</span> Analytics & Reports
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">System Info</h4>
            <div className="footer-info">
              <div className="footer-info-item">
                <span className="footer-info-icon">🚀</span>
                <span>Built with React & Firebase</span>
              </div>
              <div className="footer-info-item">
                <span className="footer-info-icon">🔒</span>
                <span>Secure & Reliable</span>
              </div>
              <div className="footer-info-item">
                <span className="footer-info-icon">📱</span>
                <span>Mobile Responsive</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>
              © {currentYear} <strong>Algios</strong>. All rights reserved.
            </p>
            <p className="footer-developer">
              Developed with ❤️ by <strong>Francesco Albano</strong>
            </p>
          </div>

          <div className="footer-meta">
            <span className="footer-version">v1.0.0</span>
            <span className="footer-build">
              Build {currentYear}.
              {String(new Date().getMonth() + 1).padStart(2, "0")}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
